module.exports = __webpack_public_path__ + "img/feature_wy.eda7f9e4.gif";